import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './AnswerRow.module.scss'

const AnswerRow = ({ answer, onChange, onMarkCorrect, onRemove }) => {
  const { t } = useTranslation()

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className={classNames('d-flex align-items-center', classes.row, { [classes.rowCorrect]: answer.correct })} onClick={onMarkCorrect}>
      <button
        type='button'
        className={classNames('d-inline-flex align-items-center justify-content-center', classes.marker, { [classes.markerCorrect]: answer.correct })}
        title={t('certificationBuilder.question.markCorrect')}
        aria-pressed={answer.correct}
      >
        <i className='fa fa-check' aria-hidden='true' />
      </button>
      <input
        className={classNames('flex-grow-1', classes.input)}
        value={answer.text}
        placeholder={t('certificationBuilder.question.answerPlaceholder')}
        onChange={(e) => onChange(e.target.value)}
      />
      {onRemove && (
        <button
          type='button'
          className={classes.remove}
          title={t('certificationBuilder.question.removeAnswer')}
          onClick={(e) => { e.stopPropagation(); onRemove() }}
        >
          <i className='fa fa-times' aria-hidden='true' />
        </button>
      )}
    </div>
  )
}

AnswerRow.propTypes = {
  answer: PropTypes.shape({
    text: PropTypes.string.isRequired,
    correct: PropTypes.bool.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onMarkCorrect: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
}

export default AnswerRow
